import type {
  AttributesEntity,
  ValuesEntity,
} from '@eliadmin/core/src/api/products/types/product-types';
import { Label } from '@eliadmin/core/src/components/ui/label';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '../../ui/paragraph';

export function AttributeColor({
  attribute,
  updateVariantValues,
  className = '',
}: {
  attribute: AttributesEntity;
  updateVariantValues: (attribute: AttributesEntity, value: ValuesEntity) => void;
  className?: string;
}) {
  const attrId = attribute.id;
  const filter = useCategoryStore(state => state.filter.attributes);
  const valueAttribute = filter.find(item => item.id === attrId);
  const setFilter = useCategoryStore(state => state.setFilter);

  const sortedValues = [...(attribute.values ?? [])].sort(
    (a, b) => (a.position ?? 0) - (b.position ?? 0),
  );

  return (
    <div
      className={cn(
        'grid w-full grid-cols-3 gap-3 md:grid-cols-4',
        'ea-attribute-color',
        className,
      )}
    >
      {sortedValues.map(value => {
        const isActive = valueAttribute?.values.includes(value.id);

        return (
          <div
            key={`attribute-${attribute.id}-value-${value.id}`}
            onClick={() => {
              setFilter({ selectedValue: { attribute, value } });
              updateVariantValues(attribute, value);
            }}
            className={cn(
              'col-span-1 flex w-full cursor-pointer flex-col items-center justify-center gap-2 rounded-[4px] border border-border p-3 transition-all',
              {
                'border-primary bg-primary-foreground': isActive,
              },
              'ea-attribute-color__wrapper',
            )}
          >
            <div
              className={cn('relative h-5 w-5 rounded-full', 'ea-attribute-color__content')}
              style={{ backgroundColor: value.color! }}
            ></div>
            <Label
              htmlFor={`attribute-${attribute.id}-value-${value.id}`}
              className={cn('ea-attribute-color__label')}
            >
              <Paragraph
                size="base"
                className={cn('w-full text-center font-normal', {
                  'font-bold': isActive,
                })}
              >
                {value.name}
              </Paragraph>
            </Label>
          </div>
        );
      })}
    </div>
  );
}
